<template>
  <div class="page dashboard-page">
    <el-row :gutter="15" class="wrapper">
      <el-col :md="5">
        <div class="card section">
          <p class="page-title">{{$t('miniProgram')}}</p>
          <div class="content">
            <div class="item">
              <el-link v-if="application.authorize_state === 'pending' && showBindLink" class="bind-button"  @click="handleClickBindMiniProgram">
                <el-button type="primary">{{$t('application.actions.bindMiniProgram')}}</el-button>
              </el-link>
              <div class="pending-bind-tips" v-if="application.authorize_state === 'pending' && !showBindLink">{{$t('waitForBinding')}}</div>
              <el-link v-if="application.authorize_state === 'register_pending'" class="go-register" @click="handleClickMiniProgramRegister">
                <p type="primary">{{$t('waitForWechatAudit')}}</p>
              </el-link>
              <el-link v-if="application.authorize_state === 'register_failed'"  class="go-register" @click="handleClickMiniProgramRegister">
                <p type="danger">{{$t('miniProgramRegistrationFail')}}</p>
              </el-link>
              <div v-if="application.authorize_state === 'authorized'">
                <img class="qr-code" :src="qrcode_url" />
                <p style="margin: 0;">{{ application.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </el-col>

      <el-col :md="5">
        <div class="card section">
          <p class="page-title">{{$t('yesterdayPageView')}}</p>
          <div class="content">
            <div class="item">
              <p class="name">PV</p>
              <h1><strong>{{yesterdayData.visit_pv || 0}}</strong></h1>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="5">
        <div class="card section">
          <p class="page-title">{{$t('yesterdayUserView')}}</p>
          <div class="content">
            <div class="item">
              <p class="name">UV</p>
              <h1><strong>{{yesterdayData.visit_uv || 0}}</strong></h1>
            </div>
          </div>
        </div>
      </el-col>

      <el-col :md="9">
         <div class="card section">
           <p class="page-title">{{$t('customPlan')}}</p>
           <div class="content">
             <div class="item">
               <p class="name">{{$t('standardPlan')}}
                 <strong :style="duePromotStyle">{{ duePromot }}</strong>
               </p>
               <p class="tip">
                {{$t('expiredTips')}}
                <span class="customer-connect" @click="dialogVisible = true">
                  {{$t('contactCustomer')}}
                </span>
                </p>
             </div>
           </div>
         </div>
      </el-col>
    </el-row>

    <el-row class="wrapper">
      <div class="card section">
        <div class="content">
          <div class="visit-table">
            <ECharts :options="recentWeekOfVisitsLineChartOptions" style="width:100%" />
          </div>
        </div>
      </div>
    </el-row>

    <el-row class="wrapper">
      <div class="card section">
        <div class="content">
          <div class="visit-table">
            <ECharts :options="recentWeekOfNewUserOptions" style="width:100%" />
          </div>
        </div>
      </div>
    </el-row>

    <el-row class="wrapper" :gutter="20">
      <el-col :span="12">
        <div class="card section">
          <div class="content">
            <div class="visit-table">
              <ECharts :options="membersCountInGender" style="width:100%" />
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="card section">
          <div class="content">
            <div class="visit-table">
              <ECharts :options="membersCountInUserType" style="width:100%" />
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-dialog
      :title="$t('contactCustomer')"
      :visible.sync="dialogVisible"
      width="40%" >
      <div>
        <p>{{$t('customerPhone')}}：{{ settings.customer_service_phone }}</p>
        <p>{{$t('customerEmail')}}：{{ settings.customer_service_email }}</p>
        <!-- <p>客服微信二维码：<img src="http://iph.href.lu/150x150"  width="150px;" /></p> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">{{$t('bean.actionConfirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';
  import moment from 'moment';
  import _ from 'lodash';
  import ECharts from 'vue-echarts';
  import 'echarts/lib/chart/line';
  import 'echarts/lib/component/title';
  import 'echarts/lib/component/tooltip';
  import 'echarts/lib/component/legend';
  import { abilityService } from 'beans-admin-plugin';

  @Component({
    components: { ECharts }
  })
  export default class ApplicationHome extends Vue {
    application = {
      data: {
        users_data: [],
        members_count_in_gender: {},
        members_count_in_user_type: {},
      }
    }
    settings = {
      customer_service_phone: '',
      customer_service_email: ''
    }
    yesterdayData = {}
    duePromot = this.$t('longTermEffective')
    duePromotColor = '#86888b'
    dialogVisible = false
    table = {
      data: []
    }

    get showBindLink() {
      return abilityService.can('registers.create')
    }

    get recentWeekOfVisitsLineChartOptions() {
      let xAxisData = []
      let seriesPVData = []
      let seriesUVData = []

      this.table.data.forEach((item) => {
        xAxisData.push(item.ref_date)
        seriesPVData.push(item.visit_pv)
        seriesUVData.push(item.visit_uv)
      })

      let options =  {
        title: {
          text: this.$t('visitsInTheLastWeek'),
          textStyle: {
            color: '#86888b',
            fontSize: 14,
            fontWeight: 500
          }
        },
        legend: {
          data: [this.$t('pageView'), this.$t('userView')]
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}'
        },
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: this.$t('pageView'),
            type: 'line',
            data: seriesPVData
          },
          {
            name: this.$t('userView'),
            type: 'line',
            data: seriesUVData
          },
        ]
      }

      if (seriesPVData.length === 0 && seriesUVData.length === 0) {
        options = Object.assign(options, {
          graphic: [
            {
              type: 'text',
              z: 100,
              left: 'center',
              top: 'middle',
              style: {
                fill: '#86888b',
                text: this.$t('noData'),
                font: '14px'
              }
            }
          ]
        });
      }
      return options;
    }

    get recentWeekOfNewUserOptions() {
      let xAxisData = []
      let seriesUsersData = []
      let seriesMemberData = []

      this.application.data.users_data.forEach((item) => {
        xAxisData.push(item.ref_date)
        seriesUsersData.push(item.new_users_count)
        seriesMemberData.push(item.new_members_count)
      })

      let options =  {
        title: {
          text: this.$t('newUserStatistics'),
          textStyle: {
            color: '#86888b',
            fontSize: 14,
            fontWeight: 500
          }
        },
        legend: {
          data: [this.$t('usersCount'), this.$t('membersCount')]
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}'
        },
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: this.$t('usersCount'),
            type: 'line',
            data: seriesUsersData
          },
          {
            name: this.$t('membersCount'),
            type: 'line',
            data: seriesMemberData
          },
        ]
      }

      if (seriesUsersData.length === 0 && seriesMemberData.length === 0) {
        options = Object.assign(options, {
          graphic: [
            {
              type: 'text',
              z: 100,
              left: 'center',
              top: 'middle',
              style: {
                fill: '#86888b',
                text: this.$t('noData'),
                font: '14px'
              }
            }
          ]
        });
      }
      return options;
    }

    get membersCountInGender() {
      return {
        title: {
          text: this.$t('userGenderDistribution'),
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
        },
        series: [
          {
            name: this.$t('userGender'),
            type: 'pie',
            radius: '50%',
            data: _.reduce(
              _.get(this.application, 'data.members_count_in_gender', {}),
              (memo, v, k) => { memo.push({ value: v, name: this.$t(`member.genders.${k}`) }); return memo },
              []
            ),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }

    get membersCountInUserType() {
      return {
        title: {
          text: this.$t('userTypeDistribution'),
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
        },
        series: [
          {
            name: this.$t('userType'),
            type: 'pie',
            radius: '50%',
            data: _.reduce(
              _.get(this.application, 'data.members_count_in_user_type', {}),
              (memo, v, k) => { memo.push({ value: v, name: this.$t(`member.userTypes.${k}`) }); return memo },
              []
            ),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }

    get duePromotStyle() {
      return { color: this.duePromotColor }
    }

    get qrcode_url() {
      return _.get(this.application, 'wechat_application.qrcode_url.url');
    }

    get columns() {
      return [
        {
          prop: 'ref_date',
          label: '日期'
        },
        {
          prop: 'visit_pv',
          label: '浏览量'
        },
        {
          prop: 'visit_uv',
          label: '访客量'
        }
      ];
    }

    async mounted() {
      const [application, settings, tableData, yesterdayData] = await Promise.all([
        this.$request.get('/dashboard'),
        this.$request.get('/settings'),
        this.$request.get('/dashboard/visit_data?time_type=one_week'),
        this.$request.get('/dashboard/visit_data?time_type=yesterday')
      ]);

      this.application = application || {};
      this.settings = settings || {};
      this.formatDuePromot(this.application.expired_at)
      this.table.data = tableData;
      this.yesterdayData = yesterdayData[0] || {};
    }

    formatDuePromot(expireAt) {
      if (expireAt) {
        if (new Date(expireAt) <= new Date()) {
          this.duePromotColor = '#FF5050'
          this.duePromot = this.$t('expired')
        } else {
          this.duePromot = `${this.$t('expiredTime')} ${moment(expireAt).format('YYYY-MM-DD')}`
        }
      }
    }

    handleClickBindMiniProgram() {
      this.$router.push({ name: 'bind_exists_mini_program' })
    }

    handleClickMiniProgramRegister() {
      this.$router.push({ name: 'mini_program_register' })
    }
  }
</script>
